import { getConsent, ICkyCategories } from "@/common/utils/cookieYes";

export const isCookieDeclined = async (types: (keyof ICkyCategories)[]) => {
  const consent = await getConsent();

  if (!consent.isUserActionCompleted) {
    return true;
  }

  for (const type of types) {
    if (!consent.categories[type]) {
      return true;
    }
  }

  return false;
};
